import React, { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Skeleton, Space } from "antd";
import { useTranslation } from "react-i18next";

import { useGetUserPreview } from "../../API/queries/userApiQueries";
import { AboutStudent } from "./AboutStudent";
import { AboutStay } from "./AboutStay";
import { Expectations } from "./Expectations";
import { Button } from "../../components/generic";
import { FlexBox } from "../../components/containers";

import { OverviewWrapper, AdditionalInfoWrapper } from "./styles";

export const StudentOverview: FC<{ children?: never }> = () => {
  const { id } = useParams();
  const { data: studentData, isLoading } = useGetUserPreview(id);
  const { t } = useTranslation("matches");
  const navigate = useNavigate();

  return (
    <OverviewWrapper>
      <FlexBox align="flex-start">
        {isLoading && <StudentOverviewSkeleton />}
        {!isLoading && typeof studentData !== "undefined" && (
          <>
            <AboutStudent data={studentData} />
            <AdditionalInfoWrapper>
              <Expectations
                idealMatch={studentData.ideal_match}
                matchCharacteristics={studentData.match_characteristics}
              />
              <AboutStay data={studentData} />
            </AdditionalInfoWrapper>
          </>
        )}
      </FlexBox>
      <FlexBox justify="flex-end">
        <Button
          main
          style={{
            alignSelf: "flex-end",
            margin: "1rem",
            padding: "16px 40px",
            fontSize: "18px"
          }}
          onClick={() => {
            window.history.length > 1 ? navigate(-1) : window.close();
          }}
        >
          {t("host.userInfo.buttonBack")}
        </Button>
      </FlexBox>
    </OverviewWrapper>
  );
};

const StudentOverviewSkeleton = () => (
  <>
    <Space
      style={{ width: "42%", marginRight: "40px", marginBottom: "1.5rem" }}
      direction="vertical"
      size="large"
    >
      <Skeleton avatar active />
      <Skeleton active />
      <Skeleton active />
    </Space>
    <Space
      style={{ width: "49%", marginBottom: "1.5rem" }}
      direction="vertical"
      size="large"
    >
      <Skeleton active />
      <Skeleton active />
    </Space>
  </>
);
